<!-- <app-feat-splash-screen></app-feat-splash-screen> -->
<app-loading-spinner [loading]="isLoadingSpinner"></app-loading-spinner>
<router-outlet></router-outlet>